import type { TableTheme } from '../../types';

export const defaultTexts: TableTheme['text'] = {
  selectColumns: 'Select visible columns',
  showAllColumns: 'Show all',
  hideAllColumns: 'Hide all',
  noResults: 'No results',
  exportTitle: 'Export',
  exportCopy: 'To clipboard',
  exportDownload: 'Download',
  today: 'Today',
  thisWeek: 'This week',
  thisMonth: 'This month',
  thisYear: 'This year',
  lastSevenDays: 'Last 7 days',
  lastThirtyDays: 'Last 30 days',
  clearFilters: 'Clear all filters',
  reset: 'Reset',
  loading: 'Loading',
  deselectAll: 'Deselect all',
  resetAll: 'Reset table state',
  rangeMin: 'Min',
  rangeMax: 'Max',
  calendarWeek: 'Wk',
};
